// import { findBaseBizOpInfoById, findProHistoryPageList } from "@/services/custom";
import { Button } from "antd";
import {SActionBtn, SCommonTable, SLowcodeList, STableActions} from "shj-components";
// import { createURL } from "@/utils/common";
import { useEffect, useRef, useState } from "react";
import { addTagDialog } from "./EditDesignTag";
import { historyVersionFn } from "./HistoryVersion";
// import { getOrigin } from "@/utils";
import { isArray } from "lodash";
import {findBaseBizOpInfoById, findMoaFlag, findProHistoryPageList} from "@/services/kuAccount.ts";
import {createURL} from "@/utils/common";
import {getOrigin} from "@/utils";
import {useNavigate} from "react-router-dom";
import {baseURL} from "@/api";

// 历史方案
export const ModalVersionProject = (props: any) => {
  const navigate = useNavigate()
  const trackParams = {
    ...props.trackParams,
    tool_id: 'crm',
    tool_code: '',
    tool_name: '',
    tool_link: '',
  };
  const { bizId, moaFlag } = props;
  const tableRef = useRef<any>();
  const [loading, setLoading] = useState(false);
  const [tagList, setTagList] = useState([]);

  const columns: any[] = [
    {
      title: '方案ID',
      dataIndex: 'projectsId',
      width: 200,
      fixed:'left',
    },
    {
      title: '案例ID',
      dataIndex: 'casesId',
      width: 200,
    },
    {
      title: '方案名',
      dataIndex: 'projectsName',
      width: 200,
    },
    {
      title: '版本号',
      dataIndex: 'versionNumber',
      width: 120,
    },
    {
      title: '版本描述',
      dataIndex: 'description',
      width: 200,
    },
    {
      title: '标签',
      dataIndex: 'versionType',
      width: 200,
    },
    {
      title: '创建人',
      dataIndex: 'createdBy',
      width: 200,
    },
    {
      title: '发版时间',
      dataIndex: 'publishVerTime',
      itemType: 'dateTime',
      width: 200,
    },
    {
      title: '操作',
      dataIndex: '#',
      width: 200,
      fixed:'right',
      render: (text: any, record: any) => {
        return operCellRender(record);
      },
    },
  ];

  const fetchList = () => {
    // setLoading(true);
    return new Promise(async (resolve, reject) => {
      try {
        // resolve({records: [{}]})
        findBaseBizOpInfoById({ data: { id: bizId } }).then((res: any) => {
          if (res[0]?.caseId) {
            findProHistoryPageList({
              data: {
                casesId: res[0].caseId, //案例  1318  theCaseId
                // casesDashboardId:'casesDashboardId', //控制台ID 非必传 不传返回leader控制台方案
              }
            }).then((resp: any) => {
              const records = isArray(resp?.records) ? resp.records : [];
              // resp.data.data.records.map((val: any) => {
              // if (!!val.versionType) {
              //   setIsEdite(true);
              // }
              // });
              console.log(resp, 111)
              setTagList(records);
              resolve({records, total: records.length});
            }).catch(() => {
              reject({success:false});
            });
          } else {
            resolve({records: []});
          }
        });
      } catch (e) {
        console.log('error')
        reject({ success: false });
        setLoading(false);
      }
    });
  };

  const operCellRender = (record: any) => {
    return <STableActions>
      <SActionBtn
        onClick={() => {
          // navigate(`/design/#/preview/draft/8506?tool_id=crm&tool_code=&tool_name=&tool_link=`)
          const url = createURL(`design/#/preview/draft/${record.projectsId}`, trackParams);
          // const url = createURL(`/design/#/preview/draft/8506?tool_id=crm&tool_code=&tool_name=&tool_link=`);
          window.open(baseURL.replace('/api', '') + url)
        }}
      >
        方案预览
      </SActionBtn>
      <SActionBtn
        primary
        onClick={() => {
          historyVersionFn({
            id: record.projectsId,
            trackParams,
          });
        }}
      >
        历史版本
      </SActionBtn>
    </STableActions>
  };

  const toolbarRender = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <span>数据列表</span>
        <Button
          disabled={!(moaFlag == 'pri')}
          type="primary"
          onClick={() => {
            addTagDialog({ tagList, fn: () => { tableRef.current.reload(); } });
          }}
        >
          添加版本标签
        </Button>
      </div>
    );
  };

  const extensions = {
    request: {fetchList}
  }

  return (
    <>
      <SLowcodeList ref={tableRef} config={{columns, toolbar: toolbarRender(), rowSelection: false}} {...extensions}/>
    </>
  );
};